<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="3">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker locale="vi" id="datepicker" v-model="dateRange" :model-config="dateRangeConfig"
                      :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol
        sm="3"
        xs="12"
        v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')"
      >
        <BaseSelect
          :options="districtCodeInput.options"
          :data="districtCodeInput.data"
          ref="districtCodeInput"
        ></BaseSelect>
      </CCol>
      <CCol sm="3" xs="12" v-if="!$hasAuthor('ROLE_WARD')">
        <BaseSelect
          :options="wardCodeInput.options"
          :data="wardCodeInput.data"
          ref="wardCodeInput"
        ></BaseSelect>
      </CCol>
      <CCol sm="3" xs="12">
        <BaseSelect
          :options="typeSelect.options"
          :data="typeSelect.data"
          ref="typeSelect"
        ></BaseSelect>
      </CCol>
      <CCol sm="3" xs="12">
        <BaseInput
          :options="titleInput.options"
          :data="titleInput.data"
          :listener="titleInput.listener"
        />
      </CCol>
      <CCol sm="3" xs="12">
        <BaseSelect
          :options="sourceTypeSelect.options"
          :data="sourceTypeSelect.data"
          ref="sourceTypeSelect"
        ></BaseSelect>
      </CCol>
      <CCol sm="3" xs="12">
        <BaseSelect :options="departmentsInput.options" :data="departmentsInput.data"
                    ref="departmentsInput"></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow class="row-2">

    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>

          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-else></td>
          </template>
          <template #level="{ item }">
            <td>
              <span class="badge badge-success" v-if="item.level == 0">Bình thường</span>
              <span class="badge badge-warning" v-if="item.level == 1">Ưu tiên</span>
              <span class="badge badge-danger" v-if="item.level == 2">Khẩn cấp</span>
            </td>
          </template>
          <template #description="{ item }">
            <td>
              <span class="description" :key="item.id" v-c-tooltip.hover="item.description">{{
                  item.description
                }}</span>
            </td>
          </template>
          <template #fileTypeName="{ item }">
            <td>
              <span class="badge badge-light">{{ item.fileTypeName }}</span>
            </td>
          </template>
          <template #sourceType="{ item }">
            <td>
              <span class="badge badge-light" v-if="item.sourceType == 0">Tệp tin TW</span>
              <span class="badge badge-light" v-else>Biên tập</span>
            </td>
          </template>
          <template #type="{ item }">
            <td>
              <span class="badge badge-light" v-if="item.type == 0 && item.isRun == true">Văn bản - Chữ chạy</span>
              <span class="badge badge-light"
                    v-else-if="item.type == 0 && item.isRun == false">Văn bản - Thông báo</span>
              <span class="badge badge-light" v-else-if="item.type == 1">Hình ảnh</span>
              <span class="badge badge-light" v-else-if="item.type == 2">Video</span>
            </td>
          </template>
          <template #url="{ item }">
            <td v-if="item.url != null">
              <span class="view-file" @click="viewFile(item.type, item.url, item.content)">Ấn vào để xem</span>
            </td>
            <td v-else></td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Tải xuống'"
                  square
                  size="sm"
                  @click="downloadFile(item.url)"
                ><i class="fa fa-download"></i>
                </CButton>
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Gửi tới nhóm bảng điện tử'"
                  square
                  @click="sendToStation(item)"
                  size="sm"><i class="fa fa-send"></i>
                </CButton>
                <CButton v-if="!$hasAuthor('ROLE_WARD')"
                         color="info"
                         variant="outline"
                         v-c-tooltip.hover="'Chia sẻ'"
                         square
                         size="sm"
                         @click="shareFile(item.id)"
                ><i class="fa fa-share"></i>
                </CButton>
<!--                <CButton-->
<!--                  color="danger"-->
<!--                  variant="outline"-->
<!--                  square-->
<!--                  size="sm"-->
<!--                  v-c-tooltip.hover="'Xóa'"-->
<!--                  @click="setupSelectOneAction('delete_one', item.id, item.title)">-->
<!--                  <CIcon name="cil-trash"/>-->
<!--                </CButton>-->
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal title="Nội dung tệp tin" :show.sync="isShowPopupContent" :closeOnBackdrop="false" size="lg">
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            {{ contentDetail }}
          </CForm>
        </CCol>
      </CRow>
      <div slot="footer">
        <CButton color="secondary" class="btn-action-primary" @click="isShowPopupContent = false"><i
          class="fa fa-times"></i> Đóng
        </CButton>
      </div>
    </CModal>

    <CModal title="Chia sẻ tệp tin" :show.sync="isShowPopupShareFile" size="lg" :closeOnBackdrop="false">
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            <CRow>
              <CCol sm="12" md="12" xl="12">
                <BaseSelect v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')"
                            :options="shareFileData.districtCodeInput.options"
                            :data="shareFileData.districtCodeInput.data"
                            ref="shareFileDistrictCodeInput"
                ></BaseSelect>
              </CCol>
              <CCol sm="12" md="12" xl="12" class="mb-2">
                <div class="form-group">
                  <label>Phường/Xã <span class="required">*</span></label>
                  <multiselect
                    class="mt-2"
                    v-model="shareFileData.wardCodeInput.data.model"
                    placeholder="Chọn phường/xã"
                    label="value"
                    track-by="key"
                    :options="shareFileData.wardCodeInput.data.items"
                    selectLabel="Chọn"
                    deselectLabel="Bỏ chọn"
                    selectedLabel="Đã chọn"
                    :close-on-select="false"
                    :multiple="true"
                    :class="!(shareFileData.wardCodeInput.data.validator ? shareFileData.wardCodeInput.data.validator.isValid : true) ? 'input-error' : ''"
                  >
                    <span slot="noResult">Không có dữ liệu tương ứng!</span>
                    <span slot="noOptions">Danh sách rỗng!</span>
                  </multiselect>
                  <div class="valid-error"
                       v-show="!(shareFileData.wardCodeInput.data.validator ? shareFileData.wardCodeInput.data.validator.isValid : true)">
                    {{
                      shareFileData.wardCodeInput.data.validator ? shareFileData.wardCodeInput.data.validator.errorMessage : ""
                    }}
                  </div>
                </div>
              </CCol>
            </CRow>
          </CForm>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <div slot="footer">
          <button type="button" class="btn btn-secondary" @click="isShowPopupShareFile = false"
                  :disabled="loadingShareFile.value"><i
            class="fa fa-close"></i> Hủy bỏ
          </button>&nbsp;
          <button type="button" class="btn btn-primary" @click="submitShareFile()" :disabled="loadingShareFile.value">
            <i class="fa fa-share"></i> Chia sẻ
          </button>
        </div>
      </template>
      <BaseFormLoading :loading="loadingShareFile.value"></BaseFormLoading>
    </CModal>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import ModalConfirm from "../../base/BaseModalConfirm";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {LOCATION_CODE_NAME, Roles} from "../../../constant";
import {DatePicker} from "v-calendar";
import Multiselect from "vue-multiselect";

export default {
  name: "ScreenFileList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    Multiselect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/screen-file/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "tệp tin",
          that.actionData.model.fileName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.fileId,
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Xóa tệp tin " + that.actionData.model.fileName + " thành công"});
        that.loadDataMainTable();
      }
    });

    return {
      loading: {
        value: false,
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          fileId: null,
          fileName: null
        }
      },
      loadingShareFile: {value: false},
      isShowPopupShareFile: false,
      isShowPopupContent: false,
      contentDetail: "",
      dateRange: {
        start: that.$helper.subtractNowDate(30).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      shareFileData: {
        fileId: {
          name: 'fileId',
          model: ''
        },
        districtCodeInput: {
          options: {
            filter: true,
            label: "Quận/Huyện <span class='required'>*</span>",
            selectAllText: "Chọn Quận/Huyện",
            keyField: "key",
            valueField: "value",
            lazyLoad: true,
          },
          data: {
            name: "districtCode",
            items: [],
            model: null,
            source: {
              url: "/common/findByParentCodeAndCode",
              dataSubmit: function () {
                return {};
              },
              response: function (dataResponse) {
                that.shareFileData.districtCodeInput.data.items = dataResponse.data;
              },
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.shareFileData.districtCodeInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Quận/Huyện không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              },
            }
          },
        },
        wardCodeInput: {
          data: {
            name: "wardCode",
            model: [],
            items: [],
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.shareFileData.wardCodeInput.data.model;
                if (!value || value.length === 0) {
                  this.isValid = false;
                  this.errorMessage = "Phường/xã không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              },
            },
          },
        },
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề tệp tin",
          label: "Tiêu đề tệp tin",
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      sourceTypeSelect: {
        options: {
          filter: false,
          label: "Nguồn tệp tin",
        },
        data: {
          name: "sourceType",
          items: [
            {key: "null", value: "Tất cả nguồn tệp tin"},
            {key: "0", value: "Tệp tin TW"},
            {key: "1", value: "Tệp tin biên tập"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      typeSelect: {
        options: {
          filter: false,
          label: "Loại tệp tin",
        },
        data: {
          name: "type",
          items: [
            {key: "null", value: "Tất cả loại tệp tin"},
            {key: "0", value: "Văn bản"},
            {key: "1", value: "Hình ảnh"},
            {key: "2", value: "Video"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          keyField: "key",
          valueField: "value",
          lazyLoad:
            this.$hasAuthor("ROLE_ADMIN") || this.$hasAuthor("ROLE_PROVINCE")
              ? false
              : true,
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: "/common/findByParentCodeAndCode",
            dataSubmit: function () {
              return {};
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            },
          },
        },
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          keyField: "key",
          valueField: "value",
          lazyLoad: this.$hasAuthor("ROLE_DISTRICT") ? false : true,
          disabled: this.$hasAuthor("ROLE_DISTRICT") ? false : true,
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: "/common/findByParentCodeAndCode",
            dataSubmit: function () {
              return {
                parentCode:
                that.districtCodeInput.data.model
              };
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            },
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      departmentsInput: {
        options: {
          filter: true,
          label: "Lĩnh vực",
          selectAllText: "Tất cả lĩnh vực",
        },
        data: {
          name: "fileTypeId",
          items: [],
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: "locationCode",
          model: "",
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT"},
            {key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%"},
            {key: "title", label: "Tiêu đề"},
            {key: "description", label: "Mô tả"},
            {key: "fileTypeName", label: "Lĩnh vực"},
            {key: "sourceType", label: "Nguồn tệp tin"},
            {key: "level", label: "Cấp độ"},
            {key: "url", label: "Nội dung tệp tin"},
            {key: "duration", label: "Thời lượng phát"},
            {key: "type", label: "Loại tệp tin"},
            {key: "location", label: "Địa bàn tạo"},
            {key: "action", label: "Thao tác"},
          ],
          slots: [
            "index",
            "createDate",
            "action",
            "sourceType",
            "level",
            "url",
            "type",
            "description",
            "fileTypeName"
          ],
          lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false,
          pageSize: 15
        },
        dataSource: {
          url: "/screen-file/getPages",
          dataSubmit: function () {
            // return that.$helper.setupDataSubmit(that.$data);
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDate(that.dateRange.start);
            params.toDate = that.$helper.formatDate(that.dateRange.end);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    async viewFile(type, url, content) {
      if (type === 0) {    /* Type = 0 là dạng văn bản */
        this.isShowPopupContent = true;
        this.contentDetail = content;
      } else {
        // let that = this;
        // this.loading.value = true;
        // const data = await this.$helper.blobFileByUrl(url);
        // setTimeout(() => {
        //   that.loading.value = false;
        //   window.open(data);
        // }, 500);
        window.open(this.$helper.viewFileByUrl(url))

        // window.open(url);
      }
    },
    async downloadFile(url) {
      this.loading.value = true;
      const imgUrl = await this.$helper.blobFileByUrl(url);
      this.loading.value = false;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = imgUrl;
      a.download = url.substring(url.lastIndexOf("/") + 1, url.length);
      a.click();
    },
    sendToStation(item) {
      this.$router.push({
        path: '/screen-editor/send-to-station.html',
        query: {fileId: item.id, sourceType: item.sourceType}
      })
    },
    loadDataDepartment: function () {
      let that = this;
      this.$helper.loadDataSource({
        url: "/common/listField",
        successCallback: function (response) {
          that.departmentsInput.data.items = response.data.data;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    shareFile: function (fileId) {
      this.shareFileData.fileId.model = fileId;
      if (this.$hasAuthor(Roles.ADMIN) || this.$hasAuthor(Roles.PROVINCE)) {
        this.$refs.shareFileDistrictCodeInput.loadData();
      } else if (this.$hasAuthor(Roles.DISTRICT)) {
        this.loadDataWard();
      }
      this.isShowPopupShareFile = true;
    },
    loadDataWard: function (parentCode) {
      let that = this;
      this.$helper.loadDataSource({
        url: '/common/findByParentCodeAndCode',
        dataSubmit() {
          return {
            parentCode: parentCode,
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.shareFileData.wardCodeInput.data.items = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      })
    },
    submitShareFile: function () {
      let that = this;
      let isValid = true;
      if (this.$hasAuthor(Roles.ADMIN) || this.$hasAuthor(Roles.PROVINCE)) {
        isValid &= this.shareFileData.districtCodeInput.data.validator.valid();
      } else if (this.$hasAuthor(Roles.DISTRICT)) {
        isValid &= this.shareFileData.wardCodeInput.data.validator.valid();
      }
      if (!isValid) {
        return;
      }
      let locations = []
      if (this.$hasAuthor(Roles.ADMIN) || this.$hasAuthor(Roles.PROVINCE)) {
        locations.push(this.shareFileData.districtCodeInput.data.model)
      }
      if (that.shareFileData.wardCodeInput.data.model) {
        for (let i = 0; i < that.shareFileData.wardCodeInput.data.model.length; i++) {
          if (that.shareFileData.wardCodeInput.data.model[i]) {
            locations.push(that.shareFileData.wardCodeInput.data.model[i].key)
          }
        }
      }
      this.loadingShareFile.value = true;
      this.$helper.loadDataSource({
        url: '/screen-file-location/add',
        dataSubmit() {
          return {
            fileId: that.shareFileData.fileId.model,
            locations: locations
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({message: "Chia sẻ tệp tin thành công"})
            that.isShowPopupShareFile = false;
            that.loadingShareFile.value = false
            that.resetDataShareFile();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loadingShareFile.value = false
        }
      })
    },
    resetDataShareFile: function () {
      this.shareFileData.fileId.model = null;
      this.shareFileData.districtCodeInput.data.model = "";
      this.shareFileData.wardCodeInput.data.model = "";
    },
    setupSelectOneAction: function (actionTypeKey, fileId, fileName) {
      let actionData = this.actionData.model;
      actionData.fileId = fileId || null;
      actionData.fileName = fileName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
    this.loadDataDepartment();
  },
  watch: {
    "districtCodeInput.data.model": function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null;
    },
    "wardCodeInput.data.model": function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
    'shareFileData.districtCodeInput.data.model': function (value) {
      if (value) {
        this.loadDataWard(value);
      } else {
        this.shareFileData.wardCodeInput.data.items = [];
      }
      this.shareFileData.wardCodeInput.data.model = null
    },
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: this.$helper.subtractNowDate(7).setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}
</style>
